// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}
.weather .city {
  width: 100%;
  font-size: 11px;
}
.weather .icon {
  width: 40px;
  height: 40px;
  margin-right: 12px;
}
.weather .icon img {
  max-height: 40px;
}
.weather .temperature {
  font-size: 24px;
  font-weight: 300;
}
.weather .description {
  width: 100%;
  font-size: 11px;
}

#dashboard-icons {
  display: grid;
  grid-template-columns: repeat(6, 108px);
  grid-template-rows: repeat(5, 108px);
  grid-column-gap: 12px;
  grid-row-gap: 24px;
}
#dashboard-icons .square {
  position: relative;
  background-color: #f9f9f8;
}
#dashboard-icons .icon {
  border-radius: 0px;
  position: absolute;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: #423830;
  padding: 0px;
  box-shadow: none;
  border: 0;
  outline: none;
}
#dashboard-icons .icon svg {
  width: 25%;
  fill: white;
}
#dashboard-icons .icon .label {
  position: absolute;
  width: 100%;
  text-align: center;
  top: 100%;
  left: 0px;
  font-size: 10px;
  line-height: 20px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AACJ;AACI;EACI,WAAA;EACA,eAAA;AACR;AAEI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ;AAII;EACI,eAAA;EACA,gBAAA;AAFR;AAKI;EACI,WAAA;EACA,eAAA;AAHR;;AAOA;EACI,aAAA;EACA,uCAAA;EACA,oCAAA;EACA,qBAAA;EACA,kBAAA;AAJJ;AAMI;EACI,kBAAA;EACA,yBAAA;AAJR;AAOI;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;AALR;AAOQ;EACI,UAAA;EACA,WAAA;AALZ;AAQQ;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AANZ","sourcesContent":[".weather {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n\r\n    .city {\r\n        width: 100%;\r\n        font-size: 11px;\r\n    }\r\n\r\n    .icon {\r\n        width: 40px;\r\n        height: 40px;\r\n        margin-right: 12px;\r\n\r\n        img {\r\n            max-height: 40px;\r\n        }\r\n    }\r\n\r\n    .temperature {\r\n        font-size: 24px;\r\n        font-weight: 300;\r\n    }\r\n\r\n    .description {\r\n        width: 100%;\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n#dashboard-icons {\r\n    display: grid;\r\n    grid-template-columns: repeat(6, 108px);\r\n    grid-template-rows: repeat(5, 108px);\r\n    grid-column-gap: 12px;\r\n    grid-row-gap: 24px;\r\n\r\n    .square {\r\n        position: relative;\r\n        background-color: #f9f9f8;\r\n    }\r\n\r\n    .icon {\r\n        border-radius: 0px;\r\n        position: absolute;\r\n        z-index: 10000;\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: #423830;\r\n        padding: 0px;\r\n        box-shadow: none;\r\n        border: 0;\r\n        outline: none;\r\n\r\n        svg {\r\n            width: 25%;\r\n            fill: white;\r\n        }\r\n\r\n        .label {\r\n            position: absolute;\r\n            width: 100%;\r\n            text-align: center;\r\n            top: 100%;\r\n            left: 0px;\r\n            font-size: 10px;\r\n            line-height: 20px;\r\n            font-weight: 400;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
